<div class="d-flex flex-column form-container">
    @if (reportIssueEnabled | async) {
        <div class="nav nav-tabs ml-3">
            <div [ngClass]="{'active': selectedTab === 0}" class="nav-item">
                <a (click)="onTabSelected(0)">
                    Feedback
                </a>
            </div>
            <div [ngClass]="{'active': selectedTab === 1}" class="nav-item">
                <a (click)="onTabSelected(1)">
                    {{ "ISSUE_REPORT_TAB" | translate }}
                </a>
            </div>
        </div>
    }
    <div class="form-module" [ngClass]="{'form-border': (reportIssueEnabled | async) }">
        <div class='header d-inline-flex justify-content-between w-100'>
            @if (selectedTab === 0) {
                <div>
          <span class="mx-1 form-title">
            {{ "CSAT_TITLE" | translate }}
          </span>
                    <p class="my-3">{{ "CSAT_ISSUE_REPORT_HINT" | translate }}</p>
                </div>

            } @else {
                <span class="mx-1 form-title">
        {{ "ISSUE_REPORT_TITLE" | translate }}
      </span>
            }
            <button type="button" class="close mx-1" (click)="dismissModal()"></button>
        </div>
        @if (selectedTab === 0) {
            <app-csat></app-csat>
        } @else {
            @if (selectedTab == 1) {
                <app-issue-report></app-issue-report>
            }
        }
        <div class="privacy">
            <p class="my-2">
                {{ 'CSAT_WARNING_MESSAGE' | translate }}
            </p>
            <a class='text' (click)='openPrivacyModal()'>
                {{ 'CSAT_PRIVACY' | translate }}
            </a>
        </div>
    </div>
</div>
